import {
  Component, EventEmitter,
  Input, OnChanges,
  OnInit, Output, SimpleChanges,
} from '@angular/core';
import {IDialogComponent} from '../iDialog.component';
import {DialogWithInput} from '../dialogWithInput';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
})
export class DialogComponent<R, DialogInput, T extends IDialogComponent<DialogInput, R>> implements OnInit, OnChanges {

  @Input() dialogWithInput: DialogWithInput<DialogInput, R>;
  @Input() manualCloseManagement = false;
  @Input() hideCloseButton = false;
  @Input() permission: string;
  @Input() permissions: string[] = [];
  @Input() noPermissionMessage: 'Vous n\avez pas les permissions suffisantes';
  @Input() noAccess = false;
  @Output() closeEvent: EventEmitter<void> = new EventEmitter<void>();

  previewContent: string;
  constructor() {

  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
  }



  close() {
    this.closeEvent.emit();
    if (!this.manualCloseManagement) {
      this.dialogWithInput.dialog.close();
    }
  }
}
